export const MILESTONE_TYPES = {
  PRE_CONTRACT: 'general',
  UNDER_CONTRACT: 'under_contract',
  AFTER_CLOSE: 'after_close',
};

export const MILESTONE_STATUSES = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
};
